import React from 'react';
import { ScrollLink } from "react-scroll";
import {Link} from "react-router-dom";
import '../../../styles/tutorial archive/Themes.css';

// Images
const Images = {
    noSprites: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Keep It Clean/NoSpritesFolder.png"),
    Sprites: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Keep It Clean/YesSpritesFolder.png"),
};

const mainSprites = {
    cursor: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Cursor.png"),
    selector: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Selector.png"),
    songbutton: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Song Button.png"),
    splicecircle_filled: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Splicable_Circle_Filled.png"),
    splicesquare_filled_thin: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Splicable_HardSquare_Filled [Thin].png"),
    spliceroundedsquare_brightw: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Splicable_RoundedSquare [BrightWhite].png"),
    spliceroundedsquare_filled: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Splicable_RoundedSquare_Filled.png"),
    toggle: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/Toggle.png"),
    uibutton: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Main Sprites/UI Button [Long].png"),

}

const reactiveSprites = {
    nl_streak: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/NorthLeft Streak.png"),
    nr_streak: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/NorthRight Streak.png"),
    sr_streak: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/SouthRight Streak.png"),
    p_streak: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/Pedestal.png"),
    sl_streak: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/SouthLeft Streak.png"),
    plainblack: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/PlainBlack.png"),
    hexagon: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/TransparentHexagon.png"),
    triangle: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/TransparentTriangle.png"),
    mainhexagon: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Reactive Menu Sprites/MainHexagon.png"),

}

const menuIconSprites = {
    mania: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Menu Icon Sprites/Mania.png"),
    person: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Menu Icon Sprites/Person.png"),
    people: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Menu Icon Sprites/People.png"),
    global: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Menu Icon Sprites/Global.png"),
    settings: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Menu Icon Sprites/Settings.png"),
    exit: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Menu Icon Sprites/Exit.png"),
}

const marketplaceSprites = {
    download: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Marketplace Sprites/DownloadButton.png"),
    report: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Marketplace Sprites/ReportButton.png"),
    trash: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Marketplace Sprites/TrashCan.png"),
}

const gameSprites = {
    track: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Game Sprites/Track.png"),
    note: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Game Sprites/Note.png"),
    whitePress: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Game Sprites/WhitePress.png"),
    key: require("../../../Assets/Tutorials/Themes Tutorial/Page 4 - Configurable Sprites/Game Sprites/Key.png"),
}

const otherAssets = {
    square: require("../../../Assets/Website Pack/Square.png"),
}

export default function configurableSprites() {
    return (
        <div className="about-frame">
            <div id="about">
                <p>Configurable Sprites</p>
            </div>
            <div className="simple-center-align">
            <span className="normal-text">
                    There's no file for this one, because Poly Beats automatically picks these up.
                <br></br>
The key to make all this work is via file names. Your file names have to EXACTLY match the ones used in-game (yes, this means you'll have to use .pngs most of the time!), so make sure to check them carefully!

            <br></br><br></br>
            Now, this next step isn't required for the game to pick up the sprites, but to just keep our folder clean,
                let's go back to Henry (the folder we made in the Introduction page)... </span>


                <img
                    src={Images.noSprites}
                    style={{height: "136px", width: "848px"}}
                    alt="Custom Menu.png!"
                />

                <span className="normal-text">
        and create a new folder in him called "Sprites".
    </span>

                <img
                    src={Images.Sprites}
                    style={{height: "136px", width: "848px"}}
                    alt="Custom Menu.png!"
                />
            </div>

            <span className="normal-text">
        From here, you can either copy the images from below into that folder, or create some for your own with the guidelines below! We reccommend programs like Krita and Paint.Net for this stuff. But it's all up to you. :)
    </span>


            <div className="about-leftalign">
                <br></br>
                <br></br>
                <div className="about-leftalign">
                    <p><br/><br/>TABLE OF CONTENTS</p>

                    {/* Table of Contents */}


                    <ul className="toc">
                        <li><a href="#main-sprites">"Main" Sprites</a></li>
                        <li><a href="#reactive-menu-sprites">Reactive Menu Sprites</a></li>
                        <li><a href="#menu-icon-sprites">Menu Icon Sprites</a></li>
                        <li><a href="#marketplace-sprites">Marketplace Sprites</a></li>
                        <li><a href="#game-sprites">Game Sprites</a></li>
                        <li><a href="#next-section">Next Section: Configurable Audio Clips</a></li>
                    </ul>

                </div>


                {/* Sections to jump to */}
                <div id="configurable-sprites" className="sectionFormatting">
                    <br></br>

                    <div id="main-sprites" className="sectionFormatting">
                        <div className="excellent-spacer"><h2>Main Sprites</h2>
                            <p>Most of these are reused throughout the menus, so be careful what you remake them as.</p>

                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.cursor}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Cursor.png"</span>
                                    <span className="text-pink">Dimensions: 920px x 920px</span>
                                    <span className="text-orange">Used: As the player's cursor.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.selector}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Selector.png"</span>
                                    <span className="text-pink">Dimensions: 256px x 256px</span>
                                    <span className="text-orange">Used: As the selection image for the Difficuly Selector, and for the 'Latest' icon in the Marketplace Menu. It is 9-sliced inside Unity, by 29 on each dimension (L: 29, T: 29, R: 29, B: 29).</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.songbutton}
                                    style={{height: "44px", width: "256px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Song Button.png"</span>
                                    <span className="text-pink">Dimensions: 1021px x 176px</span>
                                    <span className="text-orange">Used: As the button for songs and as the button for themes. It is 9-sliced inside Unity, by 23 on each dimension (L: 23, T: 23, R: 23, B: 23).</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.splicecircle_filled}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Splicable_Circle_Filled.png"</span>
                                    <span className="text-pink">Dimensions: 256px x 256px</span>
                                    <span className="text-orange">Used: To bring rounded corners to the map/theme cover arts in the Marketplace Menus, and for legacy menus that use this for some reason. It is 9-sliced inside Unity, by 110  on each dimension (L: 110, T: 110, R: 110, B: 110).</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.splicesquare_filled_thin}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span
                                        className="text-white">File Name: "Splicable_HardSquare_Filled [Thin].png"</span>
                                    <span className="text-pink">Dimensions: 256px x 256px</span>
                                    <span className="text-orange">Used: for the top and bottoms of scrollbars, but mainly in the Stream! Editor (Developers get access to this until we feel its ready for public use.) It is 9-sliced inside Unity, by 5 on each dimension (L: 5, T: 5, R: 5, B: 5).</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.spliceroundedsquare_brightw}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                <span
                                    className="text-white">File Name: "Splicable_RoundedSquare [BrightWhite].png"</span>
                                    <span className="text-pink">Dimensions: 256px x 256px</span>
                                    <span className="text-orange">Used: as a mask for images in-game that require to have rounded corners, therefore any designs put in here will be reflected on anything that loads images! (So if you leave transparency anywhere, thats where nothing will be rendered.) It is 9-sliced inside Unity, by 25 on each dimension (L: 25, T: 25, R: 25, B: 25).</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.spliceroundedsquare_filled}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Splicable_RoundedSquare_Filled.png"</span>
                                    <span className="text-pink">Dimensions: 256px x 256px</span>
                                    <span className="text-orange">Used: for almost everything else. Scrollbars, dropdowns, input fields, you name it. Almost any other UI element in Poly Beats uses this texture. It is 9-sliced inside Unity, by 25 on each dimension (L: 25, T: 25, R: 25, B: 25).</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.toggle}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Toggle.png"</span>
                                    <span className="text-pink">Dimensions: 482px x 482px</span>
                                    <span className="text-orange">Used: for toggles, which are on dropdowns, but mainly inside the Settings menu. This is NOT used on the menu as the bouncing "hexagon" design.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={mainSprites.uibutton}
                                    style={{height: "63px", width: "256px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "UI Button [Long].png"</span>
                                    <span className="text-pink">Dimensions: 700px x 172px</span>
                                    <span className="text-orange">Used: as buttons... EVERYWHERE.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="reactive-menu-sprites" className="sectionFormatting">
                        <div className="excellent-spacer"><h2>Reactive Menu Sprites</h2>
                            <p>These sprites are used for the main menu in the game.</p>

                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.nl_streak}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "NorthLeft Streak.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span className="text-orange">Used: as the top-left streak in Poly Beats, which is used to take the player to the song selector.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.nr_streak}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "NorthRight Streak.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span className="text-orange">Used: as the top-right streak in Poly Beats, which is used to take the player to the Multiplayer section of the game.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.sr_streak}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "SouthRight Streak.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span className="text-orange">Used: as the bottom-right streak in Poly Beats, which is used to take the player to the settings menu.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.p_streak}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Pedestal.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span className="text-orange">Used: as the bottom-center streak in Poly Beats, which is used to take the player to the leaderboards.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.sl_streak}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "SouthLeft Streak.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span className="text-orange">Used: as the bottom-center streak in Poly Beats, which is used to let the player exit the game.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.plainblack}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "PlainBlack.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span className="text-orange">Used: as the general artwork in the menu and Transition panels inside Poly Beats.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.hexagon}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "TransparentHexagon.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span
                                        className="text-orange">Used: for the dynamics of the menu, and it moves around.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.triangle}
                                    style={{height: "216px", width: "384px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "TransparentTriangle.png"</span>
                                    <span className="text-pink">Dimensions: 1920px x 1080px</span>
                                    <span
                                        className="text-orange">Used: for the dynamics of the menu, and it moves around. There's two of them.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={reactiveSprites.mainhexagon}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "MainHexagon.png"</span>
                                    <span className="text-pink">Dimensions: 482px x 482px</span>
                                    <span
                                        className="text-orange">Used: for the bouncing animation and as a game title logo holder in the center of the screen.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="menu-icons-sprites" className="sectionFormatting">

                        <div className="excellent-spacer"><h2>Menu Icons Sprites</h2>
                            <p>These sprites are used for the icons in the main menu - they show paths to different
                                parts of
                                the game.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={menuIconSprites.mania}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Mania.png"</span>
                                    <span className="text-pink">Dimensions: 512px x 512px</span>
                                    <span
                                        className="text-orange">Used: for the "Freeplay" icon on the home screen.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={menuIconSprites.person}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Person.png"</span>
                                    <span className="text-pink">Dimensions: 512px x 512px</span>
                                    <span className="text-orange">Used: for the "Rags To Riches" icon on the home screen, the "My Levels" filter in the Marketplace, and in the Leaderboard as the "Around Me" sprite.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={menuIconSprites.people}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "People.png"</span>
                                    <span className="text-pink">Dimensions: 512px x 512px</span>
                                    <span className="text-orange">Used: for the Leaderboard as the "Just Friends" sprite, and the "Friend Levels" filter in the Marketplace.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={menuIconSprites.global}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Global.png"</span>
                                    <span className="text-pink">Dimensions: 512px x 512px</span>
                                    <span className="text-orange">Used: for ALL Leaderboards as the "Global" sprite, and the "Famous!" filter in the Marketplace.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={menuIconSprites.settings}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Settings.png"</span>
                                    <span className="text-pink">Dimensions: 512px x 512px</span>
                                    <span
                                        className="text-orange">Used: as the "Settings" icon in the home screen.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={menuIconSprites.exit}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Exit.png"</span>
                                    <span className="text-pink">Dimensions: 512px x 512px</span>
                                    <span
                                        className="text-orange">Used: for the "Exit" icon on the home screen.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="marketplace-sprites" className="sectionFormatting">
                        <div className="excellent-spacer"><h2>Marketplace Sprites</h2>
                            <p>These sprites are ones exclusively used in the Marketplace for special functions.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={marketplaceSprites.download}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "DownloadButton.png"</span>
                                    <span className="text-pink">Dimensions: 1024px x 1024px</span>
                                    <span
                                        className="text-orange">Used: throughout the Marketplace as a download icon.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={marketplaceSprites.report}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "DownloadButton.png"</span>
                                    <span className="text-pink">Dimensions: 1024px x 1024px</span>
                                    <span
                                        className="text-orange">Used: throughout the Marketplace as a report icon.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={marketplaceSprites.trash}
                                    style={{height: "128px", width: "128px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "DownloadButton.png"</span>
                                    <span className="text-pink">Dimensions: 1024px x 1024px</span>
                                    <span
                                        className="text-orange">Used: throughout the Marketplace as a report icon.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="game-sprites" className="sectionFormatting">
                        <div className="excellent-spacer"><h2>Game Sprites</h2>
                            <p>These are used for the game scene, where players will typically play maps in.</p>

                            <div className="leftright-textimage-align">
                                <img
                                    src={gameSprites.track}
                                    style={{height: "320px", width: "72px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Track.png"</span>
                                    <span className="text-pink">Dimensions: 286px x 1428px</span>
                                    <span
                                        className="text-orange">Used: as a Track the notes in levels go down on.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={gameSprites.note}
                                    style={{height: "64px", width: "175px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Note.png"</span>
                                    <span className="text-pink">Dimensions: 268px x 98px</span>
                                    <span
                                        className="text-orange">Used: as a Track the notes in levels go down on, and also as the hitbox.</span>
                                    <span className="text-white">You can make this become 268x268, as we added support in favor of our own Base Game Themes - the Circle and Diamond themes.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={gameSprites.whitePress}
                                    style={{height: "64px", width: "175px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "WhitePress.png"</span>
                                    <span className="text-pink">Dimensions: 268px x 98px</span>
                                    <span
                                        className="text-orange">Used: as a "mask" that overlays the hitbox when you press an input.</span>
                                    <span className="text-white">You can also make this become 268x268, as we added support in favor of our own Base Game Themes - the Circle and Diamond themes.</span>
                                </div>
                            </div>
                            <div className="leftright-textimage-align">
                                <img
                                    src={gameSprites.key}
                                    style={{height: "160px", width: "160px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div className="leftright-stack-textimage-align">
                                    <span className="text-white">File Name: "Key.png"</span>
                                    <span className="text-pink">Dimensions: 286px x 383px</span>
                                    <span
                                        className="text-orange">Used: as a "key" throughout Poly Beats, "key" being the thing that holds the text that shows what keyboard key to press to light up the track this key is on.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="next-section" className="sectionFormatting">
                            <h2>Next Section: Configurable Audio Clips</h2>
                            <p>
                                Sound is really important in a video game. Let's sort yours out for your theme.
                            </p>

                            <Link to="/Tutorial-Archive/Themes/ConfigurableAudioClips">
                                <button className="fof-menu-button"><span>Configurable Audio -></span></button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>


    );
}
